import { render, staticRenderFns } from "./chooseType.vue?vue&type=template&id=1198987b&scoped=true&"
import script from "./chooseType.vue?vue&type=script&lang=js&"
export * from "./chooseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1198987b",
  null
  
)

export default component.exports